import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'loyaltyMoneyName',
  initialState: null as string | null,
  reducers: {
    setLoyaltyMoneyName(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setLoyaltyMoneyName } = slice.actions;

export default slice.reducer;
